module.exports = __webpack_public_path__ + "img/eu4pfm.0bffbde1.svg";